import { render, staticRenderFns } from "./MySpacePriorityTasksByAssigneeWidget.vue?vue&type=template&id=33ca2336&scoped=true&"
import script from "./MySpacePriorityTasksByAssigneeWidget.vue?vue&type=script&lang=js&"
export * from "./MySpacePriorityTasksByAssigneeWidget.vue?vue&type=script&lang=js&"
import style0 from "./MySpacePriorityTasksByAssigneeWidget.vue?vue&type=style&index=0&id=33ca2336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca2336",
  null
  
)

export default component.exports